import React, { Component, Fragment as F } from 'react';
// import * as firebase from './firebase';
// import { Footer, Header, Main } from "./components";
import { NewHeader } from './components/NewHeader';

export default class App extends Component {
  render() {
    return (
      <F>
        <NewHeader />
      </F>
    );
  }
}

// <Header />
// <Main />
// <Footer />
